<template>
  <div class="image-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <el-collapse-item title="文字" name="1">
          <div class="setting-item clearFloat">
            <text-setting-complex-update
              :fontFamily.sync="fontFamily"
              :fontSize.sync="fontSize"
              :fontWeight.sync="fontWeight"
              :fontStyle.sync="fontStyle"
              :textDecoration.sync="textDecoration"
              :lineHeight.sync="lineHeight"
              :lineHeightType.sync="lineHeightType"
              :letterSpacing.sync="letterSpacing"
              :activeArrangement.sync="activeArrangement"
              :writingMode.sync="writingMode"
              :textAlign.sync="textAlign"
              :showTextAlignSetting="true"
              :hideHighLevelSetting="true"
              :activeArrangementOrder.sync="activeArrangementOrder"
              :letterSpacingType.sync="letterSpacingType"
              :isThemeColor.sync="textIsThemeColor"
              :colorArr.sync="colorArr"
              :activeName.sync="activeNameColor"
              :showOverflowSetting="true"
              :overflowTypes="['字数', '无']"
              :contentHasLimit.sync="contentHasLimit"
              :textLimitWords.sync="textLimitLines"
              :wordOmitType.sync ="wordOmitType"
              :contentHasLimitRadio="'字数'"
              :showTextShadowSetting="true"
              :options="options"
            />
          </div>
          <div></div>
        </el-collapse-item>
        <el-collapse-item title="背景" name="2">
          <cx-background infoTips="支持上传图片" :background.sync="background" imgType="10" :options="options" />
        </el-collapse-item>
        <el-collapse-item title="图标" name="3">
          <div class="content-item verticallyCenter">
            <el-checkbox v-model="showIcon">显示图标</el-checkbox>
          </div>
          <div class="content-item mt8" v-if="showIcon">
            <img-icon-upload
              class="mb16"
              :imgSrc.sync="iconSrc"
              :iconType.sync="iconType"
              :iconColor.sync="iconColor"
              :resInfo.sync="resInfo"
            />
            <div v-show="iconSrc.length" class="content-item mb16 verticallyCenter">
              <span class="mr16 fs14">位置</span>
              <el-radio-group v-model="iconPosition">
                <el-radio label="left">左</el-radio>
                <el-radio label="right">右</el-radio>
                <el-radio label="top">上</el-radio>
                <el-radio label="bottom">下</el-radio>
              </el-radio-group>
            </div>
            <div class="verticallyCenter mb16" v-if="iconType === 'icon'">
              <span class="mr16 fs14">颜色</span>
              <cx-color-picker class="flex1" :isThemeColor.sync="iconColorIsThemeColor" :colorArr.sync="iconColor">
              </cx-color-picker>
            </div>

            <slider-and-input class="mb16" :value.sync="iconWidth" title="大小" :sliderMax="sliderMax" suffix="px" />
            <slider-and-input :value.sync="iconMargin" title="间距" :sliderMax="sliderMax" suffix="px" />
          </div>
        </el-collapse-item>
        <el-collapse-item title="边框" name="4">
          <div>
            <div class="content-item verticallyCenter mb8">
              <el-checkbox v-model="showBorder">显示边框</el-checkbox>
              <el-tooltip
                popper-class="width200"
                effect="dark"
                content="边框颜色为线性渐变或径向渐变时：背景颜色的透明度必须为1。此时背景模糊不生效；虚线、点线不生效。"
                placement="top"
                :open-delay="1000"
              >
                <span class="tips-btn icon-portal-info2"></span>
              </el-tooltip>
            </div>
            <cx-border
              v-if="showBorder"
              :borderWidth.sync="borderWidth"
              :borderStyle.sync="borderStyle"
              :borderColor.sync="borderColor"
              :borderIsThemeColor.sync="borderIsThemeColor"
              :activeNameColor.sync="borderActiveNameColor"
              :showGradientBorder="true"
              :options="options"
            />
          </div>
          <div class="content-item mt16">
            <border-radius
              :borderTypeFlag.sync="borderTypeFlag"
              :borderRadius.sync="borderRadius"
              :borderTopLeftRadius.sync="borderTopLeftRadius"
              :borderTopRightRadius.sync="borderTopRightRadius"
              :borderBottomRightRadius.sync="borderBottomRightRadius"
              :borderBottomLeftRadius.sync="borderBottomLeftRadius"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item title="边距" name="5">
          <div class="setting-item">
            <div class="content">
              <div class="content-item">
                <cx-padding
                  :paddingTypeFlag.sync="paddingTypeFlag"
                  :padding.sync="padding"
                  :paddingTop.sync="paddingTop"
                  :paddingRight.sync="paddingRight"
                  :paddingBottom.sync="paddingBottom"
                  :paddingLeft.sync="paddingLeft"
                />
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="更多" name="6">
          <div class="setting-item">
            <div class="content">
              <div class="content-item mb16">
                <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
              </div>
              <widthAndSizeAndZindex
                :options="options"
                :ids="ids"
                showSetItem="rotate"
                class="mt16"
                v-if="request_prefix !== 'bigScreen'"
              />
              <div class="content-item mt16">
                <div class="checkbox_colorPicker_container">
                  <span>阴影</span>
                  <span
                    v-show="borderShadowChecked"
                    class="icon-portal-plus theme-color right-icon"
                    @click="addBoxshadow"
                  ></span>
                </div>
                <box-shadow
                  v-show="borderShadowChecked"
                  :boxShadowH.sync="boxShadowH"
                  :boxShadowV.sync="boxShadowV"
                  :boxShadowBlur.sync="boxShadowBlur"
                  :boxShadowSpread.sync="boxShadowSpread"
                  :boxShadowColor.sync="boxShadowColor"
                ></box-shadow>
              </div>
              <div class="content-item mt16 flex">
                <span class="flex1">鼠标指针</span>
                <div class="setting-item flex1">
                  <div class="content">
                    <cx-cursor :cursorType.sync="cursorType" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item v-if="options.correlationLayoutId" title="移动端抽屉" name="7">
          <div class="setting-item">
            <div class="content-item mt16 verticallyCenter">
              <el-checkbox v-model="isDrawerMode">抽屉模式</el-checkbox>
              <el-checkbox v-model="drawer">显示抽屉</el-checkbox>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item v-show="$store.state.states.showPluginSetting" title="插件" name="8">
          <div class="setting-item">
            <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"
import TextSettingComplex from "modules/components/textSettingComplex"
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  name: "label-options-setting",
  components: { controlWidthAndSizeAndZindex, widthAndSizeAndZindex, TextSettingComplex, elementPluginSetting },
  props: { options: Object },
  data() {
    return {
      defaultImage: require("assets/images/image_placeholder.png"),
      this1: this,
      activeNames: ["1", "2"],
      hoverOpt: [],
      activeType: 1,
      shapeChecked: true,
      hoverShapeChecked: true,
      borderChecked: true,
      hoverBorderChecked: true,
      borderRadiusChecked: true,
      hoverBorderRadiusChecked: true,
      borderShadowChecked: true,
      hoverBorderShadowChecked: true,
      rotateChecked: true,
      hoverRotateChecked: true,
      sliderMax: 360,
      hoverBorderTypeFlag: 1,
      fontStyleList: [
        {
          _class: "icon-portal-text-bold1",
          isActive: false
        },
        {
          _class: "icon-portal-text-italic1",
          isActive: false
        },
        {
          _class: "icon-portal-text-underline1",
          isActive: false
        }
      ],
      fontFamilyList: [
        {
          value: "默认",
          label: "default"
        },
        {
          value: "默认字体",
          label: "PingFang SC"
        }
      ],
      borderStyleList: [
        {
          value: "solid",
          label: "实线",
          title: "",
          src: require("assets/images/solid-1.png")
        },
        {
          value: "dashed",
          label: "虚线",
          title: "",
          src: require("assets/images/dashed-1.png")
        },
        {
          value: "dotted",
          label: "点线",
          title: "",
          src: require("assets/images/dotted-1.png")
        }
      ],
      bgTypes: [
        {
          name: "自定义"
        },
        {
          name: "图片"
        }
      ],
      arrangementList: [
        {
          label: "左对齐",
          className: "icon-portal-text-leftt1",
          value: "left"
        },
        {
          label: "右对齐",
          className: "icon-portal-text-right1",
          value: "right"
        },
        {
          label: "居中对齐",
          className: "icon-portal-text-center1",
          value: "center"
        },
        {
          label: "两端对齐",
          className: "icon-portal-text-both1",
          value: "justify"
        }
      ]
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    activeRect() {
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    cursorType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "cursorType", "cursorType", "")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "cursorType", false)
      }
    },
    width: {
      get() {
        return this.options.width || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "width", false)
      }
    },
    height: {
      get() {
        return this.options.height || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "height", false)
      }
    },
    left: {
      get() {
        return this.options.left || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "left", false)
      }
    },
    top: {
      get() {
        return this.options.top || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "top", false)
      }
    },
    fontSize: {
      get() {
        return this.options.fontSize || 12
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontSize", false)
      }
    },
    fontStyle: {
      get() {
        return this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontStyle", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontWeight", false)
      }
    },
    lineHeight: {
      get() {
        return this.options.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeight", false)
      }
    },
    lineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "lineHeightType", "lineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeightType", false)
      }
    },
    textDecoration: {
      get() {
        return this.options.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textDecoration", false)
      }
    },
    color: {
      get() {
        return this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    textIsThemeColor: {
      get() {
        return this.options.textIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIsThemeColor", false)
      }
    },
    bgColorIsThemeColor: {
      get() {
        return this.options.bgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColorIsThemeColor", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColor", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.bgColorIsThemeColor,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "background", false)
      }
    },
    colorArr: {
      get() {
        let color = this.options.colorArr
        if (color && JSON.stringify(color) !== "{}") {
          return color
        }
        let newColor = {
          type: "color",
          label: "颜色",
          isThemeColor: false,
          data: {
            angle: 0,
            stops: [
              [this.options.color, 0],
              [this.options.color, 1]
            ]
          }
        }
        this.$changeOptionsEV(newColor, "colorArr", false, false, false, true)
        return newColor
      },
      set(val) {
        this.$changeOptionsEV(val, "colorArr", false)
      }
    },
    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontFamily", false)
      }
    },
    shapeType: {
      get() {
        return this.options.shapeType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "shapeType", false)
      }
    },
    borderTopLeftRadius: {
      get() {
        return Number(this.options.borderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return Number(this.options.borderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return Number(this.options.borderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.options.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        if (this.options.showBorder === undefined) {
          if (this.options.borderWidth) {
            showBorder = true
          } else {
            showBorder = false
          }
        } else {
          showBorder = this.options.showBorder
        }
        return showBorder
      },
      set(newVal) {
        if(newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showBorder", false)
        }
      }
    },
    borderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderWidth", "borderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.options.borderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    borderActiveNameColor: {
      get() {
        return this.options.borderActiveNameColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderActiveNameColor", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.boxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    // 边距
    paddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("paddingTypeFlag")) {
          if (((this.paddingTop === this.paddingRight) === this.paddingLeft) === this.paddingBottom) {
            defaultType = 2
          }
        }
        return this.options.paddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.options.padding || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.options.paddingTop || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.options.paddingRight || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.options.paddingLeft || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.options.paddingBottom || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    rotate: {
      get() {
        return parseInt(this.options.rotate)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rotate", false)
      }
    },
    imgSrc: {
      get() {
        return this.options.imgSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "imgSrc", false)
      }
    },
    clipSize: {
      get() {
        return this.options.clipSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "clipSize", false)
      }
    },
    bgType: {
      get() {
        return this.options.bgType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgType", false)
      }
    },
    repeatType: {
      get() {
        return this.options.repeatType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "repeatType", false)
      }
    },
    alignType: {
      get() {
        return this.options.alignType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "alignType", false)
      }
    },
    activeArrangement() {
      return this.options.textAlign
    },
    opacity: {
      get() {
        return this.options.hasOwnProperty("opacity") ? parseInt(this.options.opacity * 100) : 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal / 100, "opacity", false)
      }
    },
    hasTextAlign: {
      get() {
        return this.options.hasTextAlign || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hasTextAlign", false)
      }
    },
    textAlign: {
      get() {
        return this.options.hasTextAlign ? this.options.textAlign : "center"
      },
      set(newVal) {
        this.hasTextAlign = true
        this.$changeOptionsEV(newVal, "textAlign", false)
      }
    },
    activeArrangementOrder: {
      get() {
        return {
          label: "竖排文字",
          _class: "icon-portal-text-down1",
          isActive: this.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.writingMode = val
      }
    },
    writingMode: {
      get() {
        return this.options.writingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "writingMode", false)
      }
    },
    letterSpacing: {
      get() {
        return this.options.letterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacing", false)
      }
    },
    iconPosition: {
      get() {
        return this.options.iconPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconPosition", false)
      }
    },
    showIcon: {
      get() {
        let showIcon = false
        if (this.options.showIcon === undefined) {
          if (this.options.iconSrc) {
            showIcon = true
          } else {
            showIcon = false
          }
        } else {
          showIcon = this.options.showIcon
        }
        return showIcon
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showIcon", false)
      }
    },
    iconSrc: {
      get() {
        return this.options.iconSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconSrc", false)
      }
    },
    iconType: {
      get() {
        return this.options.iconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconType", false)
      }
    },
    iconWidth: {
      get() {
        return this.options.iconWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconWidth", false)
      }
    },
    iconMargin: {
      get() {
        return this.options.iconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconMargin", false)
      }
    },
    iconColor: {
      get() {
        return this.options.iconColor || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColor", false)
      }
    },
    iconColorIsThemeColor: {
      get() {
        return this.options.iconColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColorIsThemeColor", false)
      }
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    contentHasLimit: {
      get() {
        return this.options.contentHasLimit
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "contentHasLimit", false)
      }
    },
    textLimitLines: {
      get() {
        return this.options.textLimitLines
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textLimitLines", false)
      }
    },
    wordOmitType:{
      get() {
        return this.options.wordOmitType || "hidden"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "wordOmitType", false)
      }
    },
    activeNameColor: {
      get() {
        return this.options.activeNameColor || "first"
      },
      set(val) {
        this.$changeOptionsEV(val, "activeNameColor", false)
      }
    },
    resInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "resInfo", "resInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "resInfo", false)
      }
    },
    letterSpacingType: {
      get() {
        return this.options.letterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacingType", false)
      }
    },
    isDrawerMode: {
      get() {
        const path = this.options.correlationLayoutId
        if (!path) {
          return false
        }
        const stage = this.$store.state[this.request_prefix]
        const { drawerParams } = this.getAttrById(stage, { pageLayoutId: path }, "pageLayout").options
        return drawerParams.isDrawerMode
      },
      set(newVal) {
        const path = this.options.correlationLayoutId
        this.$changeOptionsEV(newVal, "drawerParams.isDrawerMode", false, null, { pageLayoutId: path })
      }
    },
    drawer: {
      get() {
        const path = this.options.correlationLayoutId
        if (!path) {
          return false
        }
        const stage = this.$store.state[this.request_prefix]
        const { drawerParams } = this.getAttrById(stage, { pageLayoutId: path }, "pageLayout").options
        return drawerParams.drawer
      },
      set(newVal) {
        const path = this.options.correlationLayoutId
        this.$changeOptionsEV(newVal, "drawerParams.drawer", false, null, { pageLayoutId: path })
      }
    }
  },
  methods: {
    switchHandle(type) {
      this.activeType = type
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    getFocus(event) {
      event.currentTarget.select()
    }
  }
})
</script>
